var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorfulSemicircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 159,
    viewBox: "0 0 230 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3206 64.926C10.808 45.0375 11.0466 23.9937 17.0089 4.23539",
    stroke: "#FE9700",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8558 119.237C34.1952 104.974 22.1705 86.0635 16.3212 64.9263",
    stroke: "#25C5D9",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.305 144.583C121.082 146.555 105.615 145.318 90.8979 140.953C76.1812 136.588 62.5412 129.19 50.8555 119.237",
    stroke: "#42A4F5",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.159 119.387C177.023 133.076 157.285 141.823 136.306 144.583",
    stroke: "#EB407A",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M227.195 67.283C221.142 87.5838 209.317 105.686 193.159 119.386",
    stroke: "#673BB6",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M229.05 67.8395C228.939 68.2083 228.721 68.536 228.425 68.7812C228.128 69.0264 227.765 69.1781 227.382 69.217C226.999 69.2559 226.612 69.1804 226.272 68.9999C225.932 68.8195 225.653 68.5422 225.471 68.2032C225.288 67.8641 225.21 67.4786 225.247 67.0953C225.283 66.712 225.433 66.3481 225.676 66.0497C225.919 65.7513 226.246 65.5317 226.614 65.4188C226.982 65.3059 227.375 65.3047 227.744 65.4153C228.239 65.5637 228.654 65.9024 228.899 66.357C229.144 66.8116 229.198 67.3449 229.05 67.8395Z",
    fill: "white",
    stroke: "#673BB6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.927 120.528C196.704 121.27 196.266 121.93 195.669 122.423C195.071 122.916 194.34 123.221 193.569 123.299C192.798 123.376 192.022 123.224 191.338 122.86C190.653 122.496 190.093 121.937 189.726 121.255C189.36 120.572 189.204 119.796 189.279 119.024C189.354 118.253 189.656 117.521 190.147 116.922C190.638 116.322 191.296 115.882 192.037 115.657C192.778 115.431 193.57 115.431 194.312 115.656C195.304 115.956 196.136 116.638 196.626 117.551C197.117 118.465 197.225 119.535 196.927 120.528Z",
    fill: "white",
    stroke: "#EB407A",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8432 67.9918C19.6568 68.6134 19.2902 69.1657 18.7898 69.579C18.2894 69.9922 17.6777 70.2478 17.0321 70.3134C16.3864 70.379 15.7358 70.2517 15.1626 69.9476C14.5893 69.6434 14.1191 69.1761 13.8114 68.6048C13.5037 68.0334 13.3723 67.3836 13.4339 66.7375C13.4955 66.0915 13.7473 65.4782 14.1574 64.9753C14.5676 64.4724 15.1176 64.1023 15.7381 63.912C16.3585 63.7217 17.0215 63.7197 17.6431 63.9061C18.4766 64.1562 19.1767 64.7271 19.5893 65.4933C20.0019 66.2595 20.0932 67.1582 19.8432 67.9918Z",
    fill: "white",
    stroke: "#FE9700",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.184 146.058C140.904 146.993 140.352 147.823 139.599 148.445C138.847 149.066 137.926 149.45 136.955 149.548C135.984 149.647 135.006 149.454 134.144 148.996C133.282 148.538 132.575 147.834 132.114 146.975C131.652 146.115 131.455 145.137 131.549 144.166C131.643 143.194 132.023 142.272 132.642 141.517C133.26 140.761 134.088 140.206 135.022 139.922C135.956 139.637 136.953 139.636 137.887 139.919C138.508 140.104 139.086 140.409 139.588 140.818C140.09 141.227 140.506 141.732 140.813 142.302C141.119 142.873 141.31 143.498 141.374 144.143C141.437 144.788 141.373 145.438 141.184 146.058Z",
    fill: "white",
    stroke: "#42A4F5",
    strokeWidth: 1.26,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8174 120.151C54.5899 120.909 54.1426 121.583 53.5322 122.087C52.9217 122.591 52.1755 122.903 51.3878 122.983C50.6001 123.063 49.8064 122.908 49.107 122.537C48.4076 122.166 47.8339 121.596 47.4585 120.899C47.0831 120.201 46.9229 119.409 46.998 118.621C47.0732 117.832 47.3804 117.084 47.8808 116.471C48.3811 115.857 49.0522 115.406 49.8091 115.173C50.5661 114.941 51.3749 114.939 52.1332 115.166C53.1502 115.471 54.0042 116.168 54.5076 117.103C55.011 118.037 55.1224 119.134 54.8174 120.151Z",
    fill: "white",
    stroke: "#25C5D9",
    strokeWidth: 1.62,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4664 4.77875C19.3254 5.24883 19.0481 5.66654 18.6697 5.97907C18.2913 6.29159 17.8287 6.48487 17.3404 6.53449C16.8522 6.58411 16.3602 6.48783 15.9266 6.25782C15.4931 6.02781 15.1375 5.67442 14.9048 5.24232C14.6721 4.81021 14.5728 4.3188 14.6194 3.83024C14.666 3.34168 14.8564 2.87791 15.1665 2.49757C15.4767 2.11723 15.8927 1.83741 16.3619 1.69349C16.8311 1.54957 17.3324 1.54801 17.8025 1.68901C18.4329 1.8781 18.9623 2.30985 19.2743 2.88929C19.5864 3.46872 19.6555 4.14839 19.4664 4.77875Z",
    fill: "white",
    stroke: "#FE9700",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorfulSemicircle);
export default __webpack_public_path__ + "static/media/colorful-semicircle.2f91dcb97782cd780f5bb411b21a5b52.svg";
export { ForwardRef as ReactComponent };